import type { TargetAndTransition, Variants } from "framer-motion";

const buttonVariants: Variants & {
	loading: TargetAndTransition;
	idle: TargetAndTransition;
	tap: TargetAndTransition;
} = {
	loading: {
		scale: [1, 0.95, 1],
		transition: {
			duration: 0.6,
			repeat: Infinity,
		},
	},
	idle: {
		scale: 1,
		opacity: 1,
	},
	tap: {
		scale: 0.95,
	},
};

export { buttonVariants };
